<template>
  <div class="main">
    <mt-header
      :title="$t('NFT接收地址')"
      class="dl_header_white dl_line_bottom"
      fixed
    >
      <mt-button icon="back" slot="left" @click="$router.back()"></mt-button>
    </mt-header>
    <div class="mainbody">
      <div class="qrbox">
        <div ref="qrCodeUrl" id="qrcode" class="qrborder"></div>
      </div>
      <div style="font-size: 12px; margin-top: 25px; color: #8b8b8b">
        {{ $t("此地址仅用于NFT钱包地址接收使用") }}
      </div>
      <div
        style="
          font-size: 14px;
          margin-top: 25px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        "
      >
        {{ address }}
      </div>
      <button class="btn" @click="nftcopy($event, address)">
        {{ $t("复制") }}
      </button>
    </div>
  </div>
</template>
<script>
import handleClipboard from "@/utils/clipboard";
import QRCode from "qrcodejs2";
import { Toast } from "mint-ui";
import { mynftaddress } from "../../api/nft";
export default {
  data() {
    return {
      address: "",
      qrcode: "",
    };
  },
  activated() {
    if (this.qrcode) {
      this.$refs.qrCodeUrl.innerHTML = "";
    }
    mynftaddress().then(({ data }) => {
      this.address = data.address;
      this.qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: this.address,
        width: 150,
        height: 150,
      });
    });
  },
  mounted() {},
  methods: {
    //nft复制
    nftcopy(event, val) {
      handleClipboard(
        val,
        event,
        () => {
          Toast(this.$t("fuzhicg"));
        },
        () => {
          Toast(this.$t("fuzhicc"));
        }
      );
    },
  },
};
</script>
<style scoped>
.main {
  box-sizing: border-box;
}
.mainbody {
  padding: 140px 10px 0;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.btn {
  width: 100%;
  padding: 14px 0;
  background-color: #4492d4;
  color: #fff;
  font-size: 15px;
  margin-top: 25px;
}
.qrbox {
  border: 6px solid #e2ecfa;
}
.qrborder {
  margin: 10px;
}
</style>
